import { Button } from 'react-bootstrap';
import styled from 'styled-components';
import { useLongPress } from 'use-long-press';
import { CardOption } from '../../types/TrainingTypes';

const threshold = 500;
const cancelOnMovement = 5;

export default function ChoiceOptions(props: {
    options: CardOption[],
    backgrounds: string[],
    chooseOption: (x: CardOption | undefined, isLong: boolean) => void,
}) {
    const { options, backgrounds, chooseOption } = props;
    const longPress0 = useLongPress(() => { }, {
        threshold,
        cancelOnMovement,
        onFinish: x => x.type === 'pointerup' && chooseOption(options[0], true),
    });
    const longPress1 = useLongPress(() => { }, {
        threshold,
        cancelOnMovement,
        onFinish: x => x.type === 'pointerup' && chooseOption(options[1], true),
    });
    const longPress2 = useLongPress(() => { }, {
        threshold,
        cancelOnMovement,
        onFinish: x => x.type === 'pointerup' && chooseOption(options[2], true),
    });
    const longPress3 = useLongPress(() => { }, {
        threshold,
        cancelOnMovement,
        onFinish: x => x.type === 'pointerup' && chooseOption(options[3], true),
    });
    const longPressNoOption = useLongPress(() => { }, {
        threshold,
        cancelOnMovement,
        onFinish: x => x.type === 'pointerup' && chooseOption(undefined, true),
    });

    return (
        <div className="row g-2 g-sm-3 my-2 options">
            <div className="col-12 col-sm-6">
                <Button variant="light"
                    size="lg"
                    className={backgrounds[0]}
                    onClick={() => chooseOption(options[0], false)}
                    {...longPress0()}>

                    {options[0].content}
                    {options[0].contentAux &&
                        <span className="fs-3 text-secondary"> {options[0].contentAux}</span>}
                </Button>
            </div>

            <div className="col-12 col-sm-6">
                <Button variant="light"
                    size="lg"
                    className={backgrounds[1]}
                    onClick={() => chooseOption(options[1], false)}
                    {...longPress1()}>

                    {options[1].content}
                    {options[1].contentAux &&
                        <span className="fs-3 text-secondary"> {options[1].contentAux}</span>}
                </Button>
            </div>

            <div className="col-12 col-sm-6">
                <Button variant="light"
                    size="lg"
                    className={backgrounds[2]}
                    onClick={() => chooseOption(options[2], false)}
                    {...longPress2()}>

                    {options[2].content}
                    {options[2].contentAux &&
                        <span className="fs-3 text-secondary"> {options[2].contentAux}</span>}
                </Button>
            </div>

            <div className="col-12 col-sm-6">
                <Button variant="light"
                    size="lg"
                    className={backgrounds[3]}
                    onClick={() => chooseOption(options[3], false)}
                    {...longPress3()}>

                    {options[3].content}
                    {options[3].contentAux &&
                        <span className="fs-3 text-secondary"> {options[3].contentAux}</span>}
                </Button>
            </div>
        </div>
    );
}
